export default {
  // Navigation
  nav: {
    home: 'Главная',
    corporate: 'Корпоративная',
    collections: 'Коллекции',
    certificates: 'Сертификаты',
    sales: 'Продажи',
    contact: 'Контакт',
    humanResources: 'Человеческие ресурсы',
    hr: 'Кадры',
    dealerLogin: 'Вход дилера',
    history: 'История',
    visionMission: 'Видение и миссия',
    productionProcess: 'Производственный процесс',
    ourRegions: 'Наши регионы',
    eCatalog: 'Электронный каталог',
    ourCertificates: 'Наши сертификаты',
    dayMode: 'День',
    nightMode: 'Ночь',
    blogNews: 'Блог и новости',
    documents: 'Документы',
    search: 'Поиск...',
  },

  // Corporate submenu flat keys (used by Navigation component)
  'corporate.history': 'История',
  'corporate.visionMission': 'Видение и миссия',
  'corporate.regions': 'Наши регионы',
  'corporate.certificates': 'Наши сертификаты',
  'corporate.eCatalog': 'Электронный каталог',
  'corporate.productionProcess': 'Производственный процесс',
  'corporate.wholesaleCarpet': 'Оптовое производство ковров',
  'corporate.blogNews': 'Блог и новости',
  'corporate.gaziantepCarpet': 'Газиантеп Карпет',

  // Quick Menu
  quickMenu: {
    title: 'Быстрое меню',
    subtitle: 'MONS HALI Ковры',
    language: 'Язык',
    collections: 'Коллекции',
    dealerLogin: 'Вход дилера',
    dealerLoginDesc: 'Доступ к панели дилера',
    contact: 'Контакт',
    kvkk: 'KVKK и документы',
    whatsapp: 'WhatsApp',
    whatsappDesc: 'Отправить сообщение',
    call: 'Позвонить',
    callDesc: 'Позвонить сейчас',
  },

  // TopBanner
  topBanner: {
    quality: '✓ Гарантия качества',
    production: '✓ Производство мирового класса',
    design: '✓ Современный дизайн',
    experience: '✓ 30 лет опыта',
    certified: '✓ Сертификат ISO 9001',
    qualityAssurance: '✓ Гарантия качества',
    worldClassProduction: '✓ Производство мирового класса',
    modernDesigns: '✓ Современный дизайн',
    yearsExperience: '✓ 30 лет опыта',
    isoCertified: '✓ Сертификат ISO 9001',
  },

  // CollectionsGrid
  collectionsGrid: {
    title: '10 Специальных категорий',
    subtitle: 'Наши коллекции',
    viewAll: 'Показать все',
    wholesaleCarpet: 'Оптовый ковёр',
    wholesaleBadge: 'Оптовый ковёр',
    products: 'товаров',
    page: 'Страница',
    notFound: 'Товар не найден',
    notFoundDesc: 'В этой категории пока нет товаров.',
    showAll: 'Показать все товары',
    exploreAll: 'Откройте все коллекции',
    categories: {
      all: 'Все',
      modern: 'Оптовый ковёр',
      classic: 'Оптовый ковёр',
      minimalist: 'Оптовый ковёр',
      bohemian: 'Оптовый ковёр',
      geometric: 'Оптовый ковёр',
      natural: 'Оптовый ковёр',
      luxury: 'Оптовый ковёр',
      vintage: 'Оптовый ковёр',
      ethnic: 'Оптовый ковёр',
      kids: 'Оптовый ковёр',
    },
  },

  // Certificates
  certificates: {
    title: 'Наши сертификаты',
    subtitle: 'Наши международные сертификаты, подтверждающие качество и надёжность',
    iso9001: 'ISO 9001',
    iso9001Desc: 'Сертификат системы управления качеством',
    iso14001: 'ISO 14001',
    iso14001Desc: 'Сертификат системы экологического менеджмента',
    oeko: 'OEKO-TEX',
    oekoDesc: 'Сертификат безопасности текстильной продукции',
    ce: 'CE',
    ceDesc: 'Сертификат соответствия европейским стандартам',
  },

  // FactoryGallery
  factoryGallery: {
    title: 'Наше производственное предприятие',
    subtitle: 'Моменты с нашей фабрики, где современные технологии встречаются с мастерством',
    image1: 'Современные производственные линии',
    image2: 'Процесс контроля качества',
    image3: 'Склад готовой продукции',
    image4: 'Отдел дизайна и разработки',
    image5: 'Процесс окрашивания пряжи',
    image6: 'Упаковка и логистика',
  },

  // CustomerGallery
  customerGallery: {
    title: 'Вдохновляющие пространства',
    subtitle: 'Наши ковровые комбинации',
    description: 'Откройте для себя уникальную атмосферу, которую наши ковры создают в различных помещениях',
    newCollection: 'Новая коллекция',
    catalogButton: '2026 КАТАЛОГ',
    catalogDesc: 'Откройте нашу новую коллекцию • 10 страниц',
    modernLiving: 'Современная гостиная',
    modernLivingDesc: 'Элегантная ковровая комбинация в современной гостиной',
    mosque: 'Мечеть',
    mosqueDesc: 'Специальные ковры для мечетей с традиционными узорами',
    historicVenue: 'Историческое место',
    historicVenueDesc: 'Роскошные ковры в историческом дворце',
    bedroom: 'Спальня',
    bedroomDesc: 'Мягкие и теплые ковры для спальни',
    hotelLobby: 'Лобби отеля',
    hotelLobbyDesc: 'Впечатляющие ковры для лобби роскошного отеля',
    diningRoom: 'Столовая',
    diningRoomDesc: 'Элегантные ковры для столовой',
  },

  // SocialResponsibility
  socialResponsibility: {
    title: 'Социальная ответственность',
    subtitle: 'Шаги, которые мы предпринимаем для устойчивого будущего',
    goToCollections: 'Перейти к коллекциям',
    slide1Title: 'Производство ради зелёного будущего',
    slide1Desc: 'Мы минимизируем углеродный след с помощью экологически чистых производственных процессов и производим ковры из устойчивого сырья.',
    slide2Title: 'Мы создаём ценность для общества',
    slide2Desc: 'Мы реализуем проекты социальной ответственности в широком спектре — от образования до здравоохранения, от культуры до искусства.',
    slide3Title: 'Устойчивое сырьё',
    slide3Desc: 'Мы используем переработанную пряжу и органические волокна, являясь пионерами в сохранении природных ресурсов.',
  },

  // BlogSection
  blogSection: {
    title: 'Блог и новости',
    subtitle: 'Актуальные новости из мира текстиля и наши последние разработки',
    readMore: 'Читать далее',
    allPosts: 'Все статьи блога',
    blog1Title: 'Тенденции ковров 2024 года',
    blog1Excerpt: 'Откройте для себя самые популярные цвета, узоры и стили ковров в этом году',
    blog2Title: 'Советы по уходу за коврами',
    blog2Excerpt: 'Узнайте, как правильно ухаживать за коврами и продлить их срок службы',
    blog3Title: 'Устойчивое производство',
    blog3Excerpt: 'Наши экологически чистые производственные процессы и социальная ответственность',
  },

  // GlobalImpact
  globalImpact: {
    title: 'Обслуживание по всему миру',
    subtitle: 'Глобальное корпоративное влияние',
    description: 'Из Газиантепа в мир... Мы гордимся тем, что представляляем турецкое качество на международной арене',
    stats: {
      countries: 'Страна экспорта',
      shipments: 'Ежегодная отгрузка',
      continents: 'Охват континентов',
      sqm: 'м² экспорт ковров',
    },
    countries: {
      usa: 'США',
      germany: 'Германия',
      france: 'Франция',
      uk: 'Великобритания',
      italy: 'Италия',
      spain: 'Испания',
      netherlands: 'Нидерланды',
      belgium: 'Бельгия',
      poland: 'Польша',
      sweden: 'Швеция',
      austria: 'Австрия',
      switzerland: 'Швейцария',
      denmark: 'Дания',
      norway: 'Норвегия',
      finland: 'Финляндия',
      russia: 'Россия',
      ukraine: 'Украина',
      romania: 'Румыния',
      czechRepublic: 'Чехия',
      hungary: 'Венгрия',
      greece: 'Греция',
      portugal: 'Португалия',
      ireland: 'Ирландия',
      croatia: 'Хорватия',
      serbia: 'Сербия',
      bulgaria: 'Болгария',
      slovakia: 'Словакия',
      lithuania: 'Литва',
      latvia: 'Латвия',
      estonia: 'Эстония',
      china: 'Китай',
      japan: 'Япония',
      southKorea: 'Южная Корея',
      india: 'Индия',
      uae: 'ОАЭ',
      saudiArabia: 'Саудовская Аравия',
      qatar: 'Катар',
      kuwait: 'Кувейт',
      bahrain: 'Бахрейн',
      oman: 'Оман',
      jordan: 'Иордания',
      lebanon: 'Ливан',
      egypt: 'Египет',
      morocco: 'Марокко',
      tunisia: 'Тунис',
      algeria: 'Алжир',
      southAfrica: 'Южная Африка',
      kenya: 'Кения',
      nigeria: 'Нигерия',
      australia: 'Австралия',
      newZealand: 'Новая Зеландия',
      canada: 'Канада',
      mexico: 'Мексика',
      brazil: 'Бразилия',
      argentina: 'Аргентина',
      chile: 'Чили',
      colombia: 'Колумбия',
      peru: 'Перу',
      singapore: 'Сингапур',
      malaysia: 'Малайзия',
      thailand: 'Таиланд',
      indonesia: 'Индонезия',
      philippines: 'Филиппины',
      vietnam: 'Вьетнам',
      pakistan: 'Пакистан',
      bangladesh: 'Бангладеш',
      sriLanka: 'Шри-Ланка',
      israel: 'Израиль',
      turkey: 'Турция',
      azerbaijan: 'Азербайджан',
      kazakhstan: 'Казахстан',
      uzbekistan: 'Узбекистан',
      turkmenistan: 'Туркменистан',
      kyrgyzstan: 'Кыргызстан',
      georgia: 'Грузия',
      armenia: 'Армения',
    },
  },

  // HeroSlider
  heroSlider: {
    exploreCollections: 'Изучить коллекции',
    discoverCollection: 'Открыть коллекцию',
    slide0Title: 'Snekmax Ковры',
    slide0Desc: 'Там, где встречаются качество и изящество',
    slide1Title: 'Snekmax Ковры',
    slide1Desc: 'Там, где встречаются качество и изящество',
    slide2Title: 'Наши коллекции',
    slide2Desc: 'Неповторимые дизайны на стыке изящества и роскоши',
    slide3Title: 'Наш производственный процесс',
    slide3Desc: 'Производство, где качество и совершенство встречаются на каждом шагу',
    slide4Title: 'Коллекция Bella',
    slide4Desc: 'Неповторимые дизайны на стыке изящества и роскоши',
    slide5Title: 'Коллекция Sensitive',
    slide5Desc: 'Специальное производство для тонких прикосновений',
    slide6Title: 'Коллекция Craft',
    slide6Desc: 'Современная интерпретация народных ремёсел',
    slide7Title: 'Люксовые коллекции',
    slide7Desc: 'Эксклюзивные ковры ограниченного производства',
    slide8Title: 'Коллекция Olympus',
    slide8Desc: 'Ковёр богов — в вашем доме',
    slide9Title: 'Коллекция Pashmina',
    slide9Desc: 'Комфорт с мягкостью шёлка',
  },

  // DealerBanner
  dealerBanner: {
    title: 'Присоединяйтесь к нашей дилерской сети',
    subtitle: 'Самая престижная ковровая дилерская сеть Турции',
    subtitle2: 'Дилерская сеть ковров',
    description: 'Развивайте свой бизнес с нашими премиальными коллекциями. Воспользуйтесь эксклюзивными дилерскими ценами, маркетинговую поддержкой и привилегированными услугами.',
    cardSubtitle: 'Войдите или зарегистрируйтесь сейчас',
    activeDealers: 'Активный дилер',
    provinceCoverage: 'Охват провинций',
    cityReach: 'Охват городов',
    profitMargin: 'Маржа прибыли',
    dealerPortal: 'Портал дилера',
    dealerLogin: 'Вход дилера',
    createAccount: 'Создать учетную запись дилера',
    secureLogin: 'Безопасный вход',
    support247: 'Поддержка 24/7',
  },

  // DealerFloat
  dealerFloat: {
    intro: 'ПРЕДСТАВЛЕНИЕ',
    dealerLogin: 'ВХОД ДИЛЕРА',
    like: 'НРАВИТСЯ',
    dealerPortal: 'Портал дилера',
    username: 'Имя пользователя',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль',
    login: 'Войти',
    companyName: 'Название компании',
    authorizedName: 'Имя уполномоченного лица',
    phone: 'Телефон',
    email: 'Электронная почта',
    city: 'Город',
    district: 'Район',
    address: 'Адрес',
    taxOffice: 'Налоговая инспекция',
    taxNumber: 'Налоговый номер',
    submit: 'Отправить',
    close: 'Закрыть',
    loginTitle: 'Вход дилера',
    registerTitle: 'Регистрация дилера',
    introTitle: 'Добро пожаловать',
    introText: 'Присоединяйтесь к нашей дилерской сети и станьте частью успеха',
    introButton: 'Начать',
  },

  // ContactFloat
  contactFloat: {
    whatsapp: 'WhatsApp',
    phone: 'Телефон',
    email: 'Электронная почта',
    location: 'Местоположение',
    message: 'Сообщение',
    dealerLogin: 'Вход дилера',
    sendMessage: 'Отправить сообщение',
    name: 'Имя',
    subject: 'Тема',
    yourMessage: 'Ваше сообщение',
    send: 'Отправить',
    close: 'Закрыть',
  },

  // Footer
  footer: {
    about: 'О нас',
    quickLinks: 'Быстрые ссылки',
    contact: 'Контакт',
    followUs: 'Следите за нами',
    allRightsReserved: 'Все права защищены',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия обслуживания',
    seoLinks: {
      title: 'Популярные категории ковров',
      wholesaleCarpet: 'Оптовая продажа ковров',
      modernCarpet: 'Современный ковер',
      luxuryCarpet: 'Роскошный ковер',
      carpetExport: 'Экспорт ковров',
      carpetProduction: 'Производство ковров',
      handwovenCarpet: 'Ковер ручной работы',
      carpetDealer: 'Дилерство ковров',
      turkishCarpet: 'Турецкий ковер',
      carpetFair: 'Ковровые выставки',
      qualityCarpet: 'Качественный ковер',
      hotelCarpet: 'Гостиничный ковер',
      vintageCarpet: 'Винтажный ковер',
      carpetWholesale: 'Оптовая торговля коврами',
      ecoCarpet: 'Экологичный ковер',
      carpetFactory: 'Ковровая фабрика',
    },
    companyName: '2026 Оптовая Ковровая Фабрика.',
  },

  // Common
  common: {
    loading: 'Загрузка...',
    error: 'Произошла ошибка',
    success: 'Успешно',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    view: 'Просмотр',
    search: 'Поиск',
    filter: 'Фильтр',
    sort: 'Сортировка',
    next: 'Далее',
    previous: 'Назад',
    close: 'Закрыть',
    open: 'Открыть',
    yes: 'Да',
    no: 'Нет',
    ok: 'ОК',
    apply: 'Применить',
    reset: 'Сбросить',
    clear: 'Очистить',
    submit: 'Отправить',
    back: 'Назад',
    continue: 'Продолжить',
    finish: 'Завершить',
    download: 'Скачать',
    upload: 'Загрузить',
    share: 'Поделиться',
    copy: 'Копировать',
    paste: 'Вставить',
    cut: 'Вырезать',
    undo: 'Отменить',
    redo: 'Повторить',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять выделение',
    more: 'Больше',
    less: 'Меньше',
    showMore: 'Показать больше',
    showLess: 'Показать меньше',
    readMore: 'Читать далее',
    readLess: 'Свернуть',
    seeMore: 'Смотреть больше',
    seeLess: 'Свернуть',
    viewAll: 'Показать все',
    viewLess: 'Свернуть',
    loadMore: 'Загрузить еще',
    refresh: 'Обновить',
    reload: 'Перезагрузить',
    retry: 'Повторить',
    goBack: 'Вернуться',
    goHome: 'На главную',
    goToTop: 'Наверх',
    scrollToTop: 'Прокрутить наверх',
    scrollToBottom: 'Прокрутить вниз',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    maximize: 'Развернуть',
    minimize: 'Свернуть',
    fullscreen: 'Полный экран',
    exitFullscreen: 'Выйти из полного экрана',
    play: 'Воспроизвести',
    pause: 'Пауза',
    stop: 'Стоп',
    mute: 'Отключить звук',
    unmute: 'Включить звук',
    volumeUp: 'Увеличить громкость',
    volumeDown: 'Уменьшить громкость',
    settings: 'Настройки',
    preferences: 'Предпочтения',
    options: 'Опции',
    help: 'Помощь',
    about: 'О программе',
    terms: 'Условия',
    privacy: 'Конфиденциальность',
    cookies: 'Файлы cookie',
    legal: 'Юридическая информация',
    contact: 'Контакт',
    support: 'Поддержка',
    feedback: 'Обратная связь',
    report: 'Отчет',
    bug: 'Ошибка',
    feature: 'Функция',
    request: 'Запрос',
    suggestion: 'Предложение',
    question: 'Вопрос',
    answer: 'Ответ',
    faq: 'Часто задаваемые вопросы',
    documentation: 'Документация',
    guide: 'Руководство',
    tutorial: 'Учебник',
    demo: 'Демо',
    example: 'Пример',
    sample: 'Образец',
    template: 'Шаблон',
    theme: 'Тема',
    language: 'Язык',
    currency: 'Валюта',
    timezone: 'Часовой пояс',
    date: 'Дата',
    time: 'Время',
    datetime: 'Дата и время',
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
    week: 'Неделя',
    month: 'Месяц',
    year: 'Год',
    day: 'День',
    hour: 'Час',
    minute: 'Минута',
    second: 'Секунда',
    am: 'AM',
    pm: 'PM',
    morning: 'Утро',
    afternoon: 'День',
    evening: 'Вечер',
    night: 'Ночь',
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday: 'Воскресенье',
    january: 'Январь',
    february: 'Февраль',
    march: 'Март',
    april: 'Апрель',
    may: 'Май',
    june: 'Июнь',
    july: 'Июль',
    august: 'Август',
    september: 'Сентябрь',
    october: 'Октябрь',
    november: 'Ноябрь',
    december: 'Декабрь',
  },

  // Blog Page
  'blog.heroLabel': '10 Новых статей',
  'blog.heroTitle': 'Новости ковровой индустрии',
  'blog.heroSubtitle':
    '<strong>Оптовая продажа ковров</strong>, международные выставки, экспортные достижения и тренды производства ковров — самые актуальные новости',
  'blog.breadcrumbHome': 'Главная',
  'blog.breadcrumbBlog': 'Блог и новости',
  'blog.categoryAll': 'Все',
  'blog.categoryFair': 'Выставка',
  'blog.categoryExport': 'Экспорт',
  'blog.categoryCollection': 'Коллекция',
  'blog.categorySustainability': 'Устойчивость',
  'blog.categoryCampaign': 'Акция',
  'blog.categoryProduction': 'Производство',
  'blog.categoryProject': 'Проект',
  'blog.categoryGuide': 'Руководство',
  'blog.seoIntro':
    'На нашей блог-странице, посвящённой <strong>оптовой продаже ковров</strong> и <strong>экспорту ковров</strong>, вы найдёте самые актуальные новости о международных <strong>ковровых выставках</strong>, презентациях новых коллекций, акциях оптовой продажи и процессах производства ковров. С более чем 30-летним опытом в ковровой индустрии мы предоставляем ценный контент оптовым покупателям и нашим дилерам.',
  'blog.readMore': 'Читать далее',
  'blog.readTime': 'чтение',
  'blog.noPostsInCategory': 'В этой категории пока нет новостей.',
  'blog.share': 'Поделиться:',
  'blog.seoCard1Title': 'Международные ковровые выставки',
  'blog.seoCard1Desc':
    'Мы расширяем нашу сеть оптовых продаж ковров, участвуя в самых престижных <strong>ковровых выставках</strong> мира — Милан, Париж, Хай-Пойнт.',
  'blog.seoCard2Title': 'Экспорт ковров',
  'blog.seoCard2Desc':
    'Мы представляем мощь турецкой ковровой индустрии на мировом рынке, осуществляя <strong>оптовый экспорт ковров</strong> в 25+ стран.',
  'blog.seoCard3Title': 'Качество и сертификаты',
  'blog.seoCard3Desc':
    'На наших сертифицированных по ISO производственных объектах мы производим ковры высочайших стандартов качества для <strong>оптовой продажи</strong>.',
  'blog.faqTitle': 'Часто задаваемые вопросы',
  'blog.faq1Q': 'Какой минимальный объём заказа для оптовой покупки ковров?',
  'blog.faq1A':
    'Минимальный объём заказа для оптовой покупки ковров варьируется в зависимости от коллекции, но обычно мы предлагаем оптовые ценовые преимущества для заказов от 100 м² и выше. Свяжитесь с нашим отделом продаж для получения подробной информации.',
  'blog.faq2Q': 'В какие страны вы экспортируете ковры?',
  'blog.faq2A':
    'Наш экспорт ковров охватывает более 25 стран. Мы активно осуществляем оптовые продажи ковров на европейском, ближневосточном, американском и азиатском рынках. Италия, Германия, Франция, США и ОАЭ — наши основные экспортные рынки.',
  'blog.faq3Q': 'Каковы условия оплаты при оптовой покупке ковров?',
  'blog.faq3A':
    'Мы предлагаем гибкие варианты оплаты для оптовых покупок ковров. Дополнительная скидка при оплате наличными, варианты рассрочки на 30-60-90 дней и аккредитивы для экспортных заказов.',
  'blog.faq4Q': 'Как я могу посетить ковровые выставки?',
  'blog.faq4A':
    'Мы регулярно участвуем в международных ковровых выставках. Вы можете посетить наш стенд на выставках в Милане, Париже и Хай-Пойнте или запросить специальную встречу. Следите за нашим блогом для получения информации о расписании выставок.',

  // Blog Posts
  'blog.post1.title':
    'Мы заняли своё место на Milano Carpet Expo 2026 — Новая эра в оптовых продажах ковров',
  'blog.post1.excerpt':
    'Наша компания привлекла внимание возможностями оптовых продаж и экспорта ковров на самой престижной ковровой выставке Европы Milano Carpet Expo 2026.',
  'blog.post1.date': '18 января 2026',
  'blog.post1.readTime': '6 мин',
  'blog.post2.title': 'High Point Market 2026: Буря турецких ковров на американском рынке',
  'blog.post2.excerpt':
    'Наши оптовые ковровые коллекции вызвали большой интерес на крупнейшей в мире выставке мебели и ковров High Point.',
  'blog.post2.date': '12 января 2026',
  'blog.post2.readTime': '7 мин',
  'blog.post3.title': 'Paris Deco Off 2026: Наши роскошные ковровые дизайны очаровали Европу',
  'blog.post3.excerpt':
    'Мы встретились с оптовыми покупателями с нашими современными и классическими ковровыми коллекциями на престижной дизайнерской выставке в Париже.',
  'blog.post3.date': '5 января 2026',
  'blog.post3.readTime': '5 мин',
  'blog.post4.title': '35 тонн экспорта ковров в 2025 году — Мы побили рекорд!',
  'blog.post4.excerpt':
    'Большой успех в оптовых продажах ковров: мы достигли рекордного показателя в истории компании, экспортировав 35 тонн ковров в 25 стран.',
  'blog.post4.date': '28 декабря 2025',
  'blog.post4.readTime': '5 мин',
  'blog.post5.title': 'Представлена коллекция ковров Весна-Лето 2026 — Новые тренды',
  'blog.post5.excerpt':
    'Наша коллекция Весна-Лето 2026, подготовленная для оптовых продаж, выделяется палитрой цветов, вдохновлённой природой, и современными узорами.',
  'blog.post5.date': '20 декабря 2025',
  'blog.post5.readTime': '6 мин',
  'blog.post6.title': 'Устойчивое производство ковров: Наш экологичный подход',
  'blog.post6.excerpt':
    'Мы вносим вклад в устойчивое будущее с помощью экологичных материалов и энергоэффективных процессов в оптовом производстве ковров.',
  'blog.post6.date': '15 декабря 2025',
  'blog.post6.readTime': '8 мин',
  'blog.post7.title': 'Специальные ценовые преимущества для оптовых покупателей ковров в 2026 году',
  'blog.post7.excerpt':
    'Стартовала наша специальная кампания оптовых продаж ковров на 2026 год. Специальные скидки для наших дилеров и оптовых покупателей.',
  'blog.post7.date': '10 декабря 2025',
  'blog.post7.readTime': '4 мин',
  'blog.post8.title':
    'Новые техники и традиционное искусство в производстве ковров ручной работы',
  'blog.post8.excerpt':
    'Мы сочетаем традиционное искусство ручного ткачества ковров с современными техниками. Наши коллекции ручной работы пользуются большим спросом.',
  'blog.post8.date': '5 декабря 2025',
  'blog.post8.readTime': '7 мин',
  'blog.post9.title': 'Специальные ковровые решения для отелей и ресторанов',
  'blog.post9.excerpt':
    'Мы предлагаем специальные решения для отелей, ресторанов и коммерческих проектов в оптовых продажах ковров.',
  'blog.post9.date': '28 ноября 2025',
  'blog.post9.readTime': '6 мин',
  'blog.post10.title': 'Руководство по уходу за коврами: Советы для долговечного использования',
  'blog.post10.excerpt':
    'Мы делимся нашим руководством по уходу за коврами для удовлетворённости клиентов после оптовой покупки.',
  'blog.post10.date': '20 ноября 2025',
  'blog.post10.readTime': '5 мин',

  // Wholesale Carpet Production Page
  'wholesale.heroLabel': 'Оптовое производство ковров и глобальная торговля',
  'wholesale.heroTitle': 'Оптовое производство ковров и глобальная торговля коврами',
  'wholesale.heroSubtitle':
    'Как ведущий оптовый производитель ковров из Газиантепа, мы экспортируем качественные ковры в более чем 50 стран. Мы — ваш надёжный партнёр на мировом рынке как оптовый поставщик ковров.',
  'wholesale.heroAlt': 'Оптовое производство ковров',
  'wholesale.ctaContact': 'Связаться с нами',
  'wholesale.ctaCollections': 'Смотреть коллекции',

  'wholesale.stat1': 'Страны экспорта',
  'wholesale.stat2': 'м² годового производства',
  'wholesale.stat3': 'Лет опыта',
  'wholesale.stat4': 'Опытных сотрудников',

  'wholesale.introLabel': 'О нас',
  'wholesale.introTitle': 'Ведущий оптовый поставщик ковров Турции',
  'wholesale.introP1':
    'Имея более 30 лет опыта, MONS HALI входит в число наиболее авторитетных оптовых производителей ковров Турции. На наших современных производственных объектах в Газиантепе мы ежедневно производим тысячи квадратных метров ковров, обеспечивая бесперебойные поставки оптовым покупателям и дистрибьюторам по всему миру.',
  'wholesale.introP2':
    'Наш широкий ассортимент в оптовых продажах ковров охватывает машинные ковры, ковры ручной работы, современные дизайны и классические коллекции. Мы создаём индивидуальные решения для каждого клиента и обеспечиваем гибкость в минимальных объёмах заказа.',
  'wholesale.introP3':
    'Благодаря сертифицированным по ISO 9001 производственным процессам, использованию сырья, соответствующего стандартам OEKO-TEX, и строгим механизмам контроля качества, мы выделяемся как надёжный бренд в экспорте ковров.',
  'wholesale.isoCertified': 'Сертифицированное производство',

  'wholesale.processLabel': 'Производственный процесс',
  'wholesale.processTitle': 'Процессы оптового производства ковров',
  'wholesale.processSubtitle':
    'Качество и точность на каждом этапе — от сырья до готового продукта. 5 ключевых процессов в нашем оптовом производстве ковров.',
  'wholesale.processBannerTitle': 'Сквозной контроль производства',
  'wholesale.processBannerDesc':
    'Каждый этап от выбора сырья до упаковки контролируется нашей командой экспертов.',
  'wholesale.process1Title': 'Выбор сырья',
  'wholesale.process1Desc':
    'Высококачественная пряжа и натуральные волокна тщательно отбираются и проходят испытания на качество.',
  'wholesale.process2Title': 'Ткачество и производство',
  'wholesale.process2Desc': 'Ковры производятся с сочетанием современных машин и умелых рук.',
  'wholesale.process3Title': 'Окрашивание и колорирование',
  'wholesale.process3Desc':
    'Яркие и стойкие цвета достигаются с использованием экологически чистых красителей.',
  'wholesale.process4Title': 'Контроль качества',
  'wholesale.process4Desc':
    'Каждый ковёр проходит многоэтапные испытания качества и проверку стандартов.',
  'wholesale.process5Title': 'Упаковка и отгрузка',
  'wholesale.process5Desc':
    'Продукция безопасно упакивается в специальную упаковку и отправляется по всему миру.',

  'wholesale.typesLabel': 'Виды ковров',
  'wholesale.typesTitle': 'Различия между машинным и ручным ковром',
  'wholesale.typesSubtitle':
    'Две основные категории производства в наших оптовых продажах ковров: современные машинные ковры и традиционные ковры ручной работы.',
  'wholesale.machineCarpetTitle': 'Машинный ковёр',
  'wholesale.machineCarpetDesc':
    'Машинные ковры, производимые на высокотехнологичных ткацких станках, являются наиболее востребованной категорией в оптовых продажах ковров. Со стандартными размерами, широким выбором цветов и конкурентными ценами они идеально подходят для крупных заказов. Ежедневная производственная мощность в тысячи квадратных метров обеспечивает быструю доставку.',
  'wholesale.handCarpetTitle': 'Ковёр ручной работы',
  'wholesale.handCarpetDesc':
    'Ковры ручной работы, созданные мастерами-ткачами, выделяются в премиальном сегменте своими уникальными узорами и текстурами. Каждый из них является произведением искусства; ковры ручной работы предпочитают отели, бутик-магазины и специальные проекты. Для оптовых заказов ковров ручной работы доступны варианты индивидуального дизайна и размеров.',
  'wholesale.tag.fast': 'Быстрое производство',
  'wholesale.tag.uniform': 'Стандартное качество',
  'wholesale.tag.affordable': 'Конкурентная цена',
  'wholesale.tag.unique': 'Уникальный дизайн',
  'wholesale.tag.artisan': 'Ручная работа',
  'wholesale.tag.premium': 'Премиум сегмент',

  'wholesale.qualityLabel': 'Контроль качества',
  'wholesale.qualityTitle': 'Контроль качества в производстве ковров',
  'wholesale.qualitySubtitle':
    'Многоэтапные процессы контроля качества в нашем оптовом производстве ковров гарантируют соответствие каждого продукта международным стандартам.',
  'wholesale.quality1Title': 'Анализ сырья',
  'wholesale.quality1Desc':
    'Вся пряжа и волокна, используемые в производстве, проходят физические и химические испытания в аккредитованных лабораториях. Стандарты, требующие сертификации OEKO-TEX, применяются неукоснительно.',
  'wholesale.quality2Title': 'Контроль в процессе производства',
  'wholesale.quality2Desc':
    'На этапах ткачества, окрашивания и отделки проводится оперативный контроль качества. Постоянно отслеживаются однородность цвета, точность рисунка и качество поверхности.',
  'wholesale.quality3Title': 'Проверка готовой продукции',
  'wholesale.quality3Desc':
    'Каждый готовый ковёр проходит комплексную финальную проверку на точность размеров, дефекты поверхности и долговечность. Продукция, не соответствующая стандартам, не отгружается.',
  'wholesale.quality4Title': 'Международная сертификация',
  'wholesale.quality4Desc':
    'Благодаря системе менеджмента качества ISO 9001, стандарту OEKO-TEX Standard 100 и сертификатам CE мы обеспечиваем международные гарантии в оптовом экспорте ковров.',
  'wholesale.qualityBannerTitle': 'Политика нулевого брака',
  'wholesale.qualityBannerDesc':
    '100% гарантия качества в каждом оптовом заказе ковров. Экспортируем с уверенностью, подкреплённой нашими международными сертификатами соответствия.',

  'wholesale.exportLabel': 'Логистика и экспорт',
  'wholesale.exportTitle': 'Логистика и процесс экспорта',
  'wholesale.exportSubtitle':
    'Благодаря нашей сети экспорта ковров, простирающейся из Газиантепа по всему миру, мы осуществляем безопасную и своевременную доставку в более чем 50 стран.',
  'wholesale.exportMapTitle': 'Глобальная сеть экспорта ковров',
  'wholesale.exportMapDesc':
    'Оптовый экспорт ковров в 50+ стран Европы, Ближнего Востока, Азии и Африки',
  'wholesale.region.europe': 'Европа',
  'wholesale.region.middleEast': 'Ближний Восток',
  'wholesale.region.asia': 'Азия',
  'wholesale.region.africa': 'Африка',
  'wholesale.logisticsTitle': 'Безопасная логистика и быстрая доставка',
  'wholesale.logisticsDesc':
    'Ваши оптовые заказы ковров доставляются безопасно благодаря специальной упаковке, застрахованному грузу и вариантам доставки от двери до двери.',

  'wholesale.turkeyLabel': 'Сила Турции',
  'wholesale.turkeyTitle': 'Производственная мощь Турции в ковровой отрасли',
  'wholesale.turkeyP1':
    'Турция, как лидер в мировом экспорте ковров, является определяющей силой на глобальном рынке. Центры производства ковров в Турции, особенно Газиантеп, вносят вклад в мировую экономику с ежегодным объёмом экспорта в миллиарды долларов.',
  'wholesale.turkeyP2':
    'Турецкая ковровая промышленность создаёт уникальные продукты, сочетающие традиционное мастерство с современными производственными технологиями. Конкурентная цена, высокое качество и широкий ассортимент дизайнов Турции в оптовом производстве ковров продолжают оставаться первым выбором мировых оптовых покупателей ковров.',
  'wholesale.turkeyP3':
    'Как один из ведущих представителей этой мощной отрасли, мы с решимостью продолжаем нашу миссию по продвижению турецкого коврового искусства в мире. Мы работаем каждый день, чтобы стать брендом Турции в экспорте ковров.',
  'wholesale.turkeyRank': 'В мировом экспорте ковров',
  'wholesale.turkeyFact1': 'Доля в мировом экспорте ковров',
  'wholesale.turkeyFact2': 'Годовой объём экспорта',
  'wholesale.turkeyFact3': 'Стран-импортёров',

  'wholesale.distLabel': 'Дистрибуция',
  'wholesale.distTitle': 'Глобальные продажи ковров и система дистрибуции',
  'wholesale.distSubtitle':
    'Прочные деловые партнёрства с оптовыми покупателями и дистрибьюторами ковров по всему миру составляют основу наших глобальных продаж ковров.',
  'wholesale.dist1Title': 'Местная дилерская сеть',
  'wholesale.dist1Desc':
    'Мы создаём сильную местную сбытовую сеть с более чем 170 активными дилерами по всей Турции. Мы предлагаем дилерам эксклюзивное ценообразование, маркетинговую поддержку и обучающие программы.',
  'wholesale.dist2Title': 'Международные дистрибьюторы',
  'wholesale.dist2Desc':
    'Мы осуществляем глобальные продажи ковров через наших авторизованных дистрибьюторов в более чем 50 странах. Мы предлагаем индивидуальные торговые условия и логистические решения для каждого региона.',
  'wholesale.dist3Title': 'Корпоративные и проектные продажи',
  'wholesale.dist3Desc':
    'Мы производим специальные оптовые решения для ковров для отелей, торговых центров, офисов и государственных проектов. Мы гарантируем конкурентные цены и быструю доставку для крупных проектов.',

  'wholesale.faqLabel': 'ЧАВО',
  'wholesale.faqTitle': 'Часто задаваемые вопросы',
  'wholesale.faq1Q': 'Каков минимальный объём заказа при оптовом производстве ковров?',
  'wholesale.faq1A':
    'Минимальный объём оптовых заказов ковров варьируется в зависимости от коллекции и типа продукта. Для заказов машинных ковров дополнительные ценовые преимущества предлагаются для заказов от 100 м² и выше. Для получения подробной информации обратитесь в наш отдел продаж.',
  'wholesale.faq2Q': 'В какие страны вы осуществляете доставку при экспорте ковров?',
  'wholesale.faq2A':
    'Мы экспортируем ковры в более чем 50 стран, включая Европу, Ближний Восток, Азию и Африку. Германия, Франция, ОАЭ, Саудовская Аравия, Китай и Япония входят в число наших основных экспортных рынков. Свяжитесь с нами для получения условий доставки в вашу страну.',
  'wholesale.faq3Q': 'Каковы ключевые различия между машинным и ручным ковром?',
  'wholesale.faq3A':
    'Машинные ковры производятся на высокоскоростных ткацких станках; они предлагают стандартное качество, быструю доставку и конкурентные цены. Ковры ручной работы ткутся вручную мастерами; каждый уникален, требует более длительного времени производства и относится к премиальному ценовому сегменту. Мы предлагаем широкий ассортимент обеих категорий в оптовых продажах ковров.',
  'wholesale.faq4Q': 'Каковы условия оплаты при оптовых заказах ковров?',
  'wholesale.faq4A':
    'Мы предлагаем гибкие варианты оплаты для оптовых закупок ковров: дополнительная скидка при оплате наличными, варианты отсрочки платежа на 30-60-90 дней и аккредитив для экспортных заказов. Долгосрочным деловым партнёрам предоставляются специальные кредитные лимиты.',
  'wholesale.faq5Q': 'Могу ли я разместить оптовый заказ ковров с индивидуальным дизайном?',
  'wholesale.faq5A':
    'Да, мы можем производить оптовые ковры с индивидуальными дизайнами, цветами и размерами для наших корпоративных клиентов и крупных покупателей. Для ковров с логотипом и индивидуальными комбинациями узоров и цветов применяются минимальные объёмы заказа. Пожалуйста, свяжитесь с нашим отделом продаж, чтобы поделиться деталями вашего проекта.',

  'wholesale.ctaTitle': 'Свяжитесь с нами для оптовых заказов ковров',
  'wholesale.ctaDesc':
    'Как оптовый поставщик ковров, мы предлагаем надёжные решения по поставкам по всему миру. Свяжитесь с нами сейчас для оптовых продаж ковров, экспорта и дистрибьюторства.',

  // Gaziantep Carpet Page
  'gaziantepCarpet.heroLabel': 'Ковровая фабрика Газиантеп и глобальный экспорт',
  'gaziantepCarpet.heroTitle': 'Gaziantep Carpet — Сердце производства ковров Турции',
  'gaziantepCarpet.heroSubtitle':
    'Как ведущий оптовый производитель ковров среди ковровых фабрик Газиантепа, мы доставляем ваши оптовые заказы ковров по всему миру с высокой производственной мощностью и надёжной логистической инфраструктурой. Мы экспортируем в 80+ стран как оптовый поставщик ковров.',
  'gaziantepCarpet.heroAlt': 'Ковровая фабрика Газиантеп',
  'gaziantepCarpet.ctaContact': 'Связаться с нами',
  'gaziantepCarpet.ctaCollections': 'Смотреть коллекции',

  'gaziantepCarpet.stat1': 'Ковровых фабрик в Газиантепе',
  'gaziantepCarpet.stat2': 'м² годового производства',
  'gaziantepCarpet.stat3': 'Стран экспорта',
  'gaziantepCarpet.stat4': 'Лет опыта',

  'gaziantepCarpet.introLabel': 'Оптовое производство ковров в Газиантепе',
  'gaziantepCarpet.introTitle': 'Оптовое производство ковров в Газиантепе и оптовый поставщик ковров',
  'gaziantepCarpet.introP1':
    'Газиантеп — один из крупнейших центров производства ковров в Турции и мире. В городе работает более 500 ковровых фабрик, ежегодный объём производства превышает 2 миллиарда квадратных метров. MONS HALI занимает лидирующие позиции в этой мощной экосистеме как оптовый поставщик ковров, обеспечивая бесперебойные качественные поставки глобальным покупателям.',
  'gaziantepCarpet.introP2':
    'На нашей ковровой фабрике в Газиантепе производятся машинные ковры, ковры ручной работы и ковры нестандартных размеров. Оптовые цены на ковры остаются конкурентоспособными благодаря высокой производственной мощности и эффективной логистической сети. Как производитель ковров, мы предлагаем индивидуальные решения для каждого клиента.',
  'gaziantepCarpet.introP3':
    'Как оптовый производитель ковров, мы регулярно экспортируем на европейские, ближневосточные и азиатские рынки. Наши производственные процессы, сертифицированные по ISO 9001, и использование сырья, соответствующего стандартам OEKO-TEX, отвечают международным стандартам качества.',
  'gaziantepCarpet.badge1': 'Ковровая фабрика Газиантеп',
  'gaziantepCarpet.badge2': 'Оптовый производитель ковров',
  'gaziantepCarpet.badge3': 'Сертификат ISO 9001',
  'gaziantepCarpet.isoCertified': 'Сертифицированное производство',

  'gaziantepCarpet.factoryBannerAlt': 'Ковровые фабрики Газиантепа',
  'gaziantepCarpet.factoryBannerTitle': 'Ковровые фабрики Газиантепа — Производственный центр мира',
  'gaziantepCarpet.factoryBannerDesc':
    'На наших современных производственных объектах в Газиантепе ежедневно производятся тысячи квадратных метров ковров. Мы к вашим услугам с высокой мощностью, быстрой доставкой и конкурентными оптовыми ценами на ковры.',

  'gaziantepCarpet.advLabel': 'Почему выбирают нас',
  'gaziantepCarpet.advTitle': 'Преимущества нашей ковровой фабрики в Газиантепе',
  'gaziantepCarpet.advSubtitle':
    'Мы выделяемся среди конкурентов 6 ключевыми преимуществами как оптовый поставщик и производитель ковров.',
  'gaziantepCarpet.adv1Title': 'Высокая производственная мощность',
  'gaziantepCarpet.adv1Desc':
    'С ежедневной производственной мощностью 50 000 м² на нашей фабрике в Газиантепе мы выполняем крупные оптовые заказы ковров в короткие сроки.',
  'gaziantepCarpet.adv2Title': 'Надёжная логистическая инфраструктура',
  'gaziantepCarpet.adv2Desc':
    'Благодаря стратегическому расположению Газиантепа и развитой логистической сети мы обеспечиваем быструю и безопасную доставку в Европу, на Ближний Восток и в Азию.',
  'gaziantepCarpet.adv3Title': 'Конкурентные оптовые цены на ковры',
  'gaziantepCarpet.adv3Desc':
    'Мы предлагаем самые конкурентоспособные оптовые цены на ковры на рынке благодаря высокой производственной эффективности и преимуществам в сырье.',
  'gaziantepCarpet.adv4Title': 'Широкий ассортимент дизайнов',
  'gaziantepCarpet.adv4Desc':
    'Мы удовлетворяем спрос каждого рынка с более чем 1000 вариантами узоров и цветов, включая современные, классические, этнические и индивидуальные дизайны.',
  'gaziantepCarpet.adv5Title': 'Международные стандарты качества',
  'gaziantepCarpet.adv5Desc':
    'Мы обеспечиваем международные гарантии в оптовом экспорте ковров с нашими сертификатами ISO 9001, OEKO-TEX и CE.',
  'gaziantepCarpet.adv6Title': 'Поддержка клиентов 24/7',
  'gaziantepCarpet.adv6Desc':
    'Мы оказываем круглосуточную поддержку по отслеживанию заказов, технической помощи и подготовке экспортных документов при оптовых закупках ковров.',

  'gaziantepCarpet.prodLabel': 'Категории продукции',
  'gaziantepCarpet.prodTitle':
    'Машинный ковёр, ковёр ручной работы и производство нестандартных размеров',
  'gaziantepCarpet.prodSubtitle':
    'Три основные категории, производимые на нашей ковровой фабрике в Газиантепе: высокопроизводительный машинный ковёр, премиальный ковёр ручной работы и ковры для специальных проектов.',
  'gaziantepCarpet.prod1Title': 'Производство машинных ковров',
  'gaziantepCarpet.prod1Desc':
    'Машинные ковры, производимые на современных ткацких станках, являются наиболее востребованной категорией в оптовых продажах ковров. Высокая ежедневная производственная мощность, стандартное качество и конкурентные оптовые цены делают их идеальными для крупных заказов.',
  'gaziantepCarpet.prod2Title': 'Производство ковров ручной работы',
  'gaziantepCarpet.prod2Desc':
    'Ковры ручной работы, созданные мастерами-ткачами Газиантепа, выделяются в премиальном сегменте. Предпочитаемые для отелей, бутик-магазинов и специальных проектов, ковры ручной работы добавляют ценность каждому пространству своими уникальными узорами и текстурами.',
  'gaziantepCarpet.prod3Title': 'Производство ковров нестандартных размеров',
  'gaziantepCarpet.prod3Desc':
    'Мы производим ковры в нестандартных размерах, цветах и комбинациях узоров для корпоративных клиентов и крупных проектов. Мы предлагаем специальные оптовые решения для отелей, торговых центров, офисов и государственных проектов.',
  'gaziantepCarpet.tag.machine': 'Машинный ковёр',
  'gaziantepCarpet.tag.bulk': 'Оптовый заказ',
  'gaziantepCarpet.tag.fast': 'Быстрая доставка',
  'gaziantepCarpet.tag.handmade': 'Ручная работа',
  'gaziantepCarpet.tag.premium': 'Премиум',
  'gaziantepCarpet.tag.unique': 'Уникальный дизайн',
  'gaziantepCarpet.tag.modern': 'Современный дизайн',
  'gaziantepCarpet.tag.custom': 'Индивидуальное производство',
  'gaziantepCarpet.tag.export': 'Экспорт',

  'gaziantepCarpet.logisticsBannerAlt': 'Логистика и экспорт ковров',
  'gaziantepCarpet.logisticsBannerTitle': 'Экспорт и логистика — Из Газиантепа в мир',
  'gaziantepCarpet.logisticsBannerDesc':
    'Благодаря стратегическому расположению Газиантепа и развитой логистической инфраструктуре мы доставляем ваши оптовые заказы ковров в Европу, на Ближний Восток и в Азию быстро и безопасно.',

  'gaziantepCarpet.exportLabel': 'Глобальный экспорт',
  'gaziantepCarpet.exportTitle': 'Продажа ковров из Турции в мир',
  'gaziantepCarpet.exportSubtitle':
    'Мы экспортируем оптовые ковры с нашей ковровой фабрики в Газиантепе в более чем 80 стран. Мы работаем с надёжными деловыми партнёрами на всех континентах, особенно в Европе и на Ближнем Востоке.',
  'gaziantepCarpet.exportMapTitle': 'Экспорт ковров из Газиантепа в 80+ стран',
  'gaziantepCarpet.exportMapDesc':
    'Оптовые продажи ковров через нашу сильную дистрибьюторскую сеть в Европе, на Ближнем Востоке, в Азии и Африке',
  'gaziantepCarpet.market1': 'Европейский рынок',
  'gaziantepCarpet.market2': 'Рынок Ближнего Востока',
  'gaziantepCarpet.market3': 'Азиатский рынок',
  'gaziantepCarpet.market4': 'Африканский рынок',

  'gaziantepCarpet.whyLabel': 'Почему Газиантеп',
  'gaziantepCarpet.whyTitle': 'Ковровые фабрики Газиантепа — Производственная мощь Турции',
  'gaziantepCarpet.whyP1':
    'Газиантеп — гигантский производственный центр, который в одиночку обеспечивает около 80% экспорта ковров Турции. С более чем 500 ковровыми фабриками, более чем 50 000 сотрудниками и ежегодным объёмом экспорта в 3 миллиарда долларов Газиантеп находится в центре мировой торговли коврами.',
  'gaziantepCarpet.whyP2':
    'Ковровые фабрики Газиантепа имеют полную экосистему — от поставок сырья до производственных технологий, от логистики до экспортной инфраструктуры. Эта мощная инфраструктура поддерживает конкурентоспособность оптовых цен на ковры и сокращает сроки доставки.',
  'gaziantepCarpet.whyP3':
    'Работая в этой мощной экосистеме как MONS HALI, мы предлагаем глобальным покупателям наилучшее соотношение цены и качества с нашей идентичностью оптового производителя ковров. Мы — ваш надёжный партнёр в оптовом производстве ковров в Газиантепе.',
  'gaziantepCarpet.whyFact1': 'Ковровых фабрик в Газиантепе',
  'gaziantepCarpet.whyFact2': 'Доля экспорта ковров Турции',
  'gaziantepCarpet.whyFact3': 'Годовой объём экспорта',
  'gaziantepCarpet.whyRank': 'В экспорте ковров Турции',

  'gaziantepCarpet.wholesaleLabel': 'Оптовые продажи ковров',
  'gaziantepCarpet.wholesaleTitle': 'Оптовый поставщик ковров и ценовые преимущества',
  'gaziantepCarpet.wholesaleSubtitle':
    'Мы являемся надёжным поставщиком для глобальных покупателей с нашими выгодными ценами и гибкими условиями оплаты в оптовых продажах ковров Газиантепа.',
  'gaziantepCarpet.wholesaleP1':
    'Оптовые цены на ковры, которые мы предлагаем как оптовый поставщик, находятся на самом конкурентоспособном уровне рынка благодаря нашей высокой производственной мощности и преимуществам в сырье. Специальные оптовые ценовые преимущества предлагаются для заказов от 100 м² и выше.',
  'gaziantepCarpet.wholesaleP2':
    'Для оптовых закупок ковров в Газиантепе доступны гибкие варианты оплаты, специальные кредитные лимиты и аккредитив для экспортных заказов. Для долгосрочных деловых партнёров предусмотрены специальное ценообразование и приоритетное планирование производства.',
  'gaziantepCarpet.wholesaleP3':
    'Как оптовый производитель ковров, мы можем производить оптовые ковры в индивидуальных дизайнах, цветах и размерах для наших корпоративных клиентов. Мы производим специальные решения для ковров с логотипом, гостиничных проектов и крупных коммерческих заказов.',
  'gaziantepCarpet.wholesaleFeature1': 'Оптовое ценовое преимущество от минимального заказа 100 м²',
  'gaziantepCarpet.wholesaleFeature2': 'Гибкая оплата: варианты отсрочки 30-60-90 дней',
  'gaziantepCarpet.wholesaleFeature3': 'Аккредитив и застрахованный груз для экспортных заказов',
  'gaziantepCarpet.wholesaleFeature4': 'Производство ковров с индивидуальным дизайном и логотипом',

  'gaziantepCarpet.faqLabel': 'ЧАВО',
  'gaziantepCarpet.faqTitle': 'Часто задаваемые вопросы',
  'gaziantepCarpet.faq1Q': 'Каков минимальный объём оптового заказа ковров в Газиантепе?',
  'gaziantepCarpet.faq1A':
    'Минимальный объём оптовых заказов ковров в Газиантепе варьируется в зависимости от типа продукта. Для заказов машинных ковров оптовые ценовые преимущества предлагаются для заказов от 100 м² и выше. Для ковров ручной работы и индивидуального производства применяются отдельные минимальные объёмы.',
  'gaziantepCarpet.faq2Q': 'В какие страны вы экспортируете с ковровой фабрики в Газиантепе?',
  'gaziantepCarpet.faq2A':
    'Мы экспортируем оптовые ковры с нашей ковровой фабрики в Газиантепе в более чем 80 стран, включая Европу, Ближний Восток, Азию и Африку. Германия, Франция, ОАЭ, Саудовская Аравия, Китай и Япония входят в число наших основных экспортных рынков.',
  'gaziantepCarpet.faq3Q': 'Как определяются оптовые цены на ковры?',
  'gaziantepCarpet.faq3A':
    'Оптовые цены на ковры определяются объёмом заказа, типом продукта, сложностью узора и условиями доставки. Благодаря нашим производственным преимуществам в Газиантепе мы можем предложить самые конкурентоспособные оптовые цены на ковры на рынке.',
  'gaziantepCarpet.faq4Q': 'Производите ли вы ковры с индивидуальным дизайном?',
  'gaziantepCarpet.faq4A':
    'Да, мы производим оптовые ковры с индивидуальными дизайнами, цветами и размерами для наших корпоративных клиентов. Для ковров с логотипом, гостиничных проектов и индивидуальных комбинаций узоров и цветов применяются минимальные объёмы заказа.',
  'gaziantepCarpet.faq5Q': 'Как работает логистика при экспорте ковров из Газиантепа?',
  'gaziantepCarpet.faq5A':
    'Благодаря стратегическому расположению Газиантепа и развитой логистической инфраструктуре мы доставляем ваши оптовые заказы ковров по всему миру автомобильным, морским и воздушным транспортом. Доступны специальная упаковка, застрахованный груз и доставка от двери до двери.',

  'gaziantepCarpet.ctaTitle': 'Свяжитесь с нами для оптовых заказов ковров из Газиантепа',
  'gaziantepCarpet.ctaDesc': 'Свяжитесь с нами сейчас для оптовых продаж ковров, оптового экспорта ковров и индивидуального производства с нашей ковровой фабрики в Газиантепе. Гарантия конкурентной цены и быстрой доставки.',

  'product.carpet001.name': 'Серый ковёр в ёлочку',
  'product.carpet001.description': 'Ковёр в ёлочку серых тонов, придающий изысканность вашим пространствам.',
  'product.carpet002.name': 'Бежевый ковёр в ёлочку',
  'product.carpet002.description': 'Классический ковёр в ёлочку в тёплых натуральных бежевых тонах, подходящий для любого интерьера.',
  'product.carpet003.name': 'Антрацитовый ковёр в ёлочку',
  'product.carpet003.description': 'Ковёр с глубоким антрацитовым цветом, идеально подходящий для современных интерьеров.',
  'product.carpet004.name': 'Кремовый ковёр в ёлочку',
  'product.carpet004.description': 'Элегантный кремовый ковёр в ёлочку, идеальный для светлых и просторных помещений.',
  'product.carpet005.name': 'Коричневый ковёр в ёлочку',
  'product.carpet005.description': 'Элегантный ковёр в тёплых коричневых тонах, подходящий для рустикальных и современных интерьеров.',
  'product.carpet006.name': 'Тёмно-синий ковёр в ёлочку',
  'product.carpet006.description': 'Элегантный ковёр с глубоким тёмно-синим цветом, создающий роскошный вид.',
  'product.carpet007.name': 'Зелёный ковёр в ёлочку',
  'product.carpet007.description': 'Ковёр, создающий свежую и спокойную атмосферу в натуральных зелёных тонах.',
  'product.carpet008.name': 'Розовый ковёр в ёлочку',
  'product.carpet008.description': 'Ковёр, добавляющий романтичный и элегантный штрих в мягких розовых тонах.',
  'product.carpet009.name': 'Бордовый ковёр в ёлочку',
  'product.carpet009.description': 'Ковёр специального дизайна для классических и роскошных интерьеров в насыщенном бордовом цвете.',
  'product.carpet010.name': 'Бирюзовый ковёр в ёлочку',
  'product.carpet010.description': 'Ковёр, добавляющий динамизм современным и энергичным пространствам с ярким бирюзовым цветом.',
  'product.carpet011.name': 'Горчичный ковёр в ёлочку',
  'product.carpet011.description': 'Ковёр, создающий весёлую и современную атмосферу в тёплом горчичном тоне.',
  'product.carpet012.name': 'Оранжевый ковёр в ёлочку',
  'product.carpet012.description': 'Ковёр специального дизайна для динамичных и смелых интерьеров в энергичном оранжевом цвете.',
  'product.carpet013.name': 'Фиолетовый ковёр в ёлочку',
  'product.carpet013.description': 'Специальный ковёр для изысканных и роскошных интерьеров в элегантных фиолетовых тонах.',
  'product.carpet014.name': 'Дымчато-серый ковёр в ёлочку',
  'product.carpet014.description': 'Универсальный ковёр, подходящий для любого интерьера в нейтральном дымчато-сером тоне.',
  'product.carpet015.name': 'Каменно-серый ковёр в ёлочку',
  'product.carpet015.description': 'Ковёр, подходящий для минималистичных и современных интерьеров в натуральном каменно-сером тоне.',
  'product.carpet016.name': 'Экрю ковёр в ёлочку',
  'product.carpet016.description': 'Элегантный ковёр, подходящий для классических и современных интерьеров в тёплом тоне экрю.',
  'product.carpet017.name': 'Норковый ковёр в ёлочку',
  'product.carpet017.description': 'Премиальный ковёр для роскошных и элегантных интерьеров в стильном норковом цвете.',
  'product.carpet018.name': 'Чёрный ковёр в ёлочку',
  'product.carpet018.description': 'Изысканный штрих для современных и минималистичных интерьеров в классическом чёрном цвете.',
  'product.carpet019.name': 'Белый ковёр в ёлочку',
  'product.carpet019.description': 'Идеальный минималистичный ковёр для светлых и просторных помещений в чисто белом цвете.',
  'product.carpet020.name': 'Серебристо-серый ковёр в ёлочку',
  'product.carpet020.description': 'Ковёр, добавляющий гламур роскошным и современным интерьерам в мерцающем серебристо-сером тоне.',
  'product.carpet021.name': 'Золотисто-жёлтый ковёр в ёлочку',
  'product.carpet021.description': 'Престижный ковёр для роскошных интерьеров в насыщенном золотисто-жёлтом тоне.',
  'product.carpet022.name': 'Бронзовый ковёр в ёлочку',
  'product.carpet022.description': 'Ковёр, добавляющий вневременную элегантность классическим и современным интерьерам в тёплом бронзовом тоне.',
  'product.carpet023.name': 'Медный ковёр в ёлочку',
  'product.carpet023.description': 'Ковёр с динамичным видом для современных и энергичных интерьеров в ярком медном цвете.',
  'product.carpet024.name': 'Оливково-зелёный ковёр в ёлочку',
  'product.carpet024.description': 'Ковёр, подходящий для спокойных и органических интерьеров в натуральном оливково-зелёном тоне.',
  'product.carpet025.name': 'Травяно-зелёный ковёр в ёлочку',
  'product.carpet025.description': 'Ковёр, добавляющий свежесть живым и энергичным пространствам в свежем травяно-зелёном тоне.',
  'product.carpet026.name': 'Морской синий ковёр в ёлочку',
  'product.carpet026.description': 'Ковёр, подходящий для спокойных и прибрежных интерьеров в тихом морском синем тоне.',
  'product.carpet027.name': 'Небесно-голубой ковёр в ёлочку',
  'product.carpet027.description': 'Ковёр, добавляющий свежий штрих светлым и просторным помещениям в светло-голубом тоне.',
  'product.carpet028.name': 'Лавандово-фиолетовый ковёр в ёлочку',
  'product.carpet028.description': 'Элегантный ковёр, подходящий для романтичных и спокойных интерьеров в мягком лавандовом тоне.',
  'product.carpet029.name': 'Коралловый ковёр в ёлочку',
  'product.carpet029.description': 'Ковёр, добавляющий динамизм энергичным и весёлым пространствам в ярком коралловом тоне.',
  'product.carpet030.name': 'Персиковый ковёр в ёлочку',
  'product.carpet030.description': 'Ковёр, создающий уютную атмосферу в тёплых и гостеприимных интерьерах в нежном персиковом цвете.',

  'product.feature.material': 'Материал',
  'product.feature.production': 'Производство',
  'product.feature.pileHeight': 'Высота ворса',
  'product.feature.base': 'Основа',

  'product.value.polypropylene': 'Полипропилен',
  'product.value.flatWeave': 'Плоское плетение',
  'product.value.machineWoven': 'Машинное плетение',
  'product.value.jute': 'Джут',
  'product.value.lowPile': 'Низкий ворс',
  'product.value.mediumPile': 'Средний ворс',
  'product.value.highPile': 'Высокий ворс',

  'product.modal.prevProduct': 'Предыдущий товар',
  'product.modal.nextProduct': 'Следующий товар',
  'product.modal.sizesTitle': 'Размеры и габариты',
  'product.modal.featuresTitle': 'Характеристики товара',
  'product.modal.productCode': 'Код товара',
  'product.modal.backToPage': 'Вернуться на страницу',
  'product.modal.zoomHint': 'Нажмите на изображение для увеличения',
  'product.modal.fullscreenHint': 'Двойной клик для увеличения · Прокрутка для масштабирования · Перетаскивание для перемещения',
  'product.modal.fullscreen': 'Полный экран',
  
  // Home Welcome
  'home.welcome.title': 'Добро пожаловать в MONS HALI',
  'home.welcome.description': 'Компания MONS HALI на протяжении многих лет производит качественные ковры. Мы предлагаем нашим клиентам лучшую продукцию благодаря современным производственным мощностям и команде экспертов.',
  'home.welcome.learnMore': 'Узнать больше',
  // Home Blog Posts
  'blog.home101.title': 'Устойчивость в текстильной промышленности',
  'blog.home101.excerpt': 'Подробная информация о наших экологически чистых производственных процессах и устойчивом подходе к текстилю.',
  'blog.home101.date': '15 марта 2024',
  'blog.home101.readTime': '5 мин',
  'blog.home102.title': 'Тенденции текстиля 2024 года',
  'blog.home102.excerpt': 'Экспертные мнения и прогнозы о тенденциях нового сезона в текстиле и цветовых палитрах.',
  'blog.home102.date': '10 марта 2024',
  'blog.home102.readTime': '7 мин',
  'blog.home103.title': 'Наши процессы контроля качества',
  'blog.home103.excerpt': 'Тщательные процессы контроля, которые мы применяем для обеспечения соответствия нашей продукции высочайшим стандартам качества.',
  'blog.home103.date': '5 марта 2024',
  'blog.home103.readTime': '6 мин',

  // Collections Hero Slider
  'collectionsHero.slide1.tag': 'Оптовая продажа ковров',
  'collectionsHero.slide1.title': 'Премиальные\nКоллекции ковров',
  'collectionsHero.slide1.subtitle': 'Оптовое производство ковров из Газиантепа в мир, экспорт в 50+ стран',
  'collectionsHero.slide1.stat1Label': 'Стран экспорта',
  'collectionsHero.slide1.stat2Label': 'Лет опыта',
  'collectionsHero.slide2.tag': 'Оптовое производство ковров',
  'collectionsHero.slide2.title': 'Центр оптовых\nпродаж ковров',
  'collectionsHero.slide2.subtitle': 'Ежедневное производство тысячи м² ковров на наших сертифицированных ISO 9001 объектах',
  'collectionsHero.slide2.stat1Label': 'Специальных коллекций',
  'collectionsHero.slide2.stat2Label': 'Активных дилеров',
  'collectionsHero.slide3.tag': 'Экспорт ковров',
  'collectionsHero.slide3.title': 'Ковровая фабрика,\nоткрытая миру',
  'collectionsHero.slide3.subtitle': 'Добавьте ценность вашим жилым пространствам с современными дизайнами и традиционным мастерством',
  'collectionsHero.slide3.stat1Label': 'м² годового производства',
  'collectionsHero.slide3.stat2Label': 'Уникальных узоров',
  'collectionsHero.cta.explore': 'Исследовать коллекции',
  'collectionsHero.cta.price': 'Получить оптовую цену',
  'collectionsHero.aria.slider': 'Слайдер коллекций ковров оптом',
  'collectionsHero.aria.slide': 'Слайд',
  'collectionsHero.aria.prev': 'Предыдущий слайд',
  'collectionsHero.aria.next': 'Следующий слайд',
  'collectionsHero.aria.goto': 'Перейти к коллекциям',

  // Vision Mission Page
  'visionMission.heroTitle': 'Видение и миссия',
  'visionMission.heroSubtitle': 'Наши цели и ценности на будущее',
  'visionMission.heroAlt': 'Видение и миссия',
  'visionMission.ourVision': 'Наше видение',
  'visionMission.visionImgAlt': 'Видение',
  'visionMission.visionP1': 'Стать ведущим брендом в области качества, инноваций и устойчивого развития в мировой ковровой индустрии. Объединить турецкое ковровое искусство с современными производственными технологиями и занять позицию наиболее предпочтительного производителя роскошных ковров на мировом рынке.',
  'visionMission.visionP2': 'К 2030 году мы стремимся присутствовать в более чем 100 странах, достичь годовой производственной мощности в 2 миллиона м² и стать пионером устойчивого производства в отрасли.',
  'visionMission.ourMission': 'Наша миссия',
  'visionMission.missionImgAlt': 'Миссия',
  'visionMission.missionP1': 'Производить роскошные ковры мирового класса, сочетающие новейшие технологии с традиционным мастерством. Добавлять ценность жилым пространствам, предлагая клиентам продукты, сочетающие эстетику, комфорт и долговечность.',
  'visionMission.missionP2': 'Служить примером для отрасли благодаря экологически чистым производственным процессам, этичным деловым практикам и принципам непрерывного совершенствования, создавая ценность для всех наших заинтересованных сторон.',
  'visionMission.ourValues': 'Наши ценности',
  'visionMission.valuesSubtitle': 'Наши основные ценности, формирующие принципы работы и ведущие нас к успеху',
  'visionMission.value1.title': 'Качество',
  'visionMission.value1.desc': 'Мы предлагаем нашим клиентам превосходные продукты, поддерживая высочайшие стандарты качества на каждом этапе производства.',
  'visionMission.value2.title': 'Устойчивость',
  'visionMission.value2.desc': 'Мы ответственно инвестируем в будущее с помощью экологически чистых производственных процессов и использования возобновляемой энергии.',
  'visionMission.value3.title': 'Инновации',
  'visionMission.value3.desc': 'Мы разрабатываем инновационные продукты и производственные технологии, задающие направление отрасли, через наши исследования и разработки.',
  'visionMission.value4.title': 'Ориентация на людей',
  'visionMission.value4.desc': 'Мы создаём счастливую и продуктивную рабочую среду, инвестируя в развитие наших сотрудников.',
  'visionMission.value5.title': 'Удовлетворённость клиентов',
  'visionMission.value5.desc': 'Мы строим долгосрочные деловые партнёрства с подходом к обслуживанию, превосходящим ожидания наших клиентов.',
  'visionMission.value6.title': 'Глобальное видение',
  'visionMission.value6.desc': 'Мы делаем нашу страну гордой, наилучшим образом представляя турецкую ковровую отрасль на мировых рынках.',
  // Contact Page (flat keys)
  'contact.title': 'Контакты',
  'contact.subtitle': 'Свяжитесь с нами',
  'contact.heroSubtitle': 'Свяжитесь с нами, мы будем рады помочь вам',
  'contact.info': 'Контактная информация',
  'contact.address': 'Адрес',
  'contact.addressValue': 'Организованная промышленная зона, 5-я улица, №42, Газиантеп, Турция',
  'contact.phone': 'Телефон',
  'contact.email': 'Электронная почта',
  'contact.workingHours': 'Часы работы',
  'contact.workingHoursValue': 'Понедельник - Пятница: 08:00 - 18:00',
  'contact.visitUs': 'Посетите нас',
  'contact.visitUsDesc': 'Вы можете записаться на приём для посещения нашего завода и шоурума.',
  'contact.mapTitle': 'Карта расположения',
  'contact.form.title': 'Отправьте нам сообщение',
  'contact.form.reachUs': 'Свяжитесь с нами',
  'contact.form.reachUsDesc': 'Заполните форму для ваших вопросов, предложений или деловых предложений, и мы свяжемся с вами как можно скорее.',
  'contact.form.name': 'Имя и фамилия',
  'contact.form.namePlaceholder': 'Ваше имя и фамилия',
  'contact.form.email': 'Электронная почта',
  'contact.form.emailPlaceholder': 'example@email.com',
  'contact.form.phone': 'Телефон',
  'contact.form.phonePlaceholder': '+90 5XX XXX XX XX',
  'contact.form.subject': 'Тема',
  'contact.form.subjectPlaceholder': 'Выберите тему',
  'contact.form.subject.general': 'Общая информация',
  'contact.form.subject.product': 'Информация о продукте',
  'contact.form.subject.dealer': 'Дилерство',
  'contact.form.subject.sales': 'Продажи',
  'contact.form.subject.support': 'Техническая поддержка',
  'contact.form.message': 'Ваше сообщение',
  'contact.form.messagePlaceholder': 'Напишите ваше сообщение здесь... (Максимум 500 символов)',
  'contact.form.send': 'Отправить',
  'contact.form.success': 'Ваше сообщение успешно отправлено.',
};
